<template>
    <div>
        <form id="formOrdemServico" class="ajax_off" @submit.prevent="submit">

            <b-form-group label="Tipo de conta para recebimento" v-slot="{ ariaDescribedby }">
                <b-form-radio v-model.number="form.tipo_de_conta" :aria-describedby="ariaDescribedby"
                    name="tipo_de_conta" value="1">Juridica</b-form-radio>
                <b-form-radio v-model.number="form.tipo_de_conta" :aria-describedby="ariaDescribedby"
                    name="tipo_de_conta" value="2">Fisica</b-form-radio>
            </b-form-group>

            <div class="form-group">
                <label>Serviço</label>

            </div><e-select name="servico_id" route="tiposServicosSelect" v-model="form.servico_id"
                modal="tipo-de-servico">
            </e-select>

            <div class="form-group">
                <label>Preço</label>
                <money name="preco" v-model="form.preco" @input="calcular()" class="form-control"></money>
            </div>

            <div class="form-group">
                <label>Imposto</label>
                <money name="imposto" v-bind="tax" v-model="form.imposto" @input="calcular()" class="form-control">
                </money>
                <!-- <input id="imposto" type="text" class="form-control calcular" v-model="form.imposto" @keyup="calcular()"
          name="imposto" /> -->
            </div>

            <div class="form-group">
                <label>Total</label>
                <money v-model="form.total" class="form-control" readonly=""></money>
            </div>

            <div class="form-group">
                <label>Condições de pagamento </label>
                <e-select name="condicao_pagamento_id" route="condicao-pagamento" v-model="form.condicao_pagamento_id">
                </e-select>
            </div>

            <div v-if="form.condicao_pagamento_id == 1">


                <div class="form-group">
                    <e-select name="opcao_pagamento_id" holder="Selecione a opção de pagamento" route="opcao-pagamento"
                        v-model="form.opcao_pagamento_id">
                    </e-select>
                </div>
                <div class="form-group" v-if="form.opcao_pagamento_id == 1 && form.tipo_de_conta">

                    <model-select name="conta_id" placeholder="Selecione a conta" :options="contasFilter"
                        v-model="form.conta_id">
                    </model-select>

                </div>
                <div class="form-group">
                    <label>Vencimento</label>
                    <date-picker name="vencimento" format="DD/MM/YYYY" v-model="form.vencimento"
                        value-type="YYYY-MM-DD"></date-picker>
                </div>
            </div>

            <div v-if="form.condicao_pagamento_id == 2">
                <div class="form-group">
                    <label>Entrada</label>
                    <money v-model="form.entrada" class="form-control" name="entrada"></money>
                </div>
                <div class="form-group">
                    <label>vencimento entrada</label>
                    <date-picker name="vencimento" placeholder="vencimento entrada" format="DD/MM/YYYY"
                        v-model="form.vencimento" :value="form.vencimento" value-type="YYYY-MM-DD"></date-picker>
                </div>

                <div class="form-group">
                    <e-select name="opcao_pagamento_id" holder="Selecione a opção de pagamento" route="opcao-pagamento"
                        v-model="form.opcao_pagamento_id">
                    </e-select>
                </div>

                <div class="form-group" v-if="form.opcao_pagamento_id == 1 && form.tipo_de_conta">
                    <model-select name="conta_id" placeholder="Selecione a conta" :options="contasFilter"
                        v-model="form.conta_id">
                    </model-select>
                </div>

                <div class="form-group">
                    <label>Quantidade de parcelas</label>
                    <input class="form-control" type="number" name="vezes" v-model.number="form.vezes" />
                </div>

                <div class="form-group">
                    <label>Opção de pagamento das parcelas</label>
                    <e-select name="forma_pagamento_parcelas" holder="Selecione a opção de pagamento parcelas"
                        route="opcao-pagamento" v-model="form.forma_pagamento_parcelas">
                    </e-select>
                </div>

                <div class="form-group" v-if="form.forma_pagamento_parcelas == 1 && form.tipo_de_conta">
                    <model-select name="conta_id_parcelas" placeholder="Selecione a conta" :options="contasFilter"
                        v-model="form.conta_id_parcelas">
                    </model-select>
                </div>

                <div class="form-group">
                    <label>vencimento da primeira parcela</label>
                    <date-picker name="vencimento_primeira_parcela" placeholder="vencimento 1ª parcela"
                        format="DD/MM/YYYY" v-model="form.vencimento_primeira_parcela"
                        value-type="YYYY-MM-DD"></date-picker>
                </div>


            </div>
        </form>

        <modal :title="` ${servico_id ? 'Atualizar' : 'Cadastrar'} tipo de serviço`" size="md" id="tipo-de-servico"
            form="tipoForm" btn_save>
            <tipoForm :servico_id="servico_id" />
        </modal>

        <modal title="Cadastro de conta" id="modalConta">
            <ContaForm></ContaForm>
        </modal>
    </div>
</template>

<script>
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";
import eSelect from "../../sistema/eSelect.vue";
import tipoForm from "../../servicos/forms/tipoForm.vue";
import ContaForm from "./ContaForm.vue";
export default {
    components: { eSelect, tipoForm, ContaForm, ModelSelect },
    name: "ServicoPreco",
    data() {
        return {
            contas: [],
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "R$ ",
                suffix: " #",
                precision: 2,
                masked: false,
            },
            tax: {
                decimal: ",",
                thousands: ".",
                prefix: "",
                suffix: "%",
                precision: 2,
                masked: false,
            },
            servico_id: null,
            condicoes_pagamento: [],

            form: {
                id: null,
                tipo_de_conta: null,
                servicos: [],
                servico: {},
                preco: 0,
                total: 0,
                imposto: 0,
                conta_id: null,
                conta_id_parcelas: null,
                momento_pagamento_vezes: [],
                condicao_pagamento_id: null,
                opcao_pagamento_id: null,
                opcao_pagamento_entrada: null,
                form_pagamento: "Selecione",
                valor_parcelamento: 0,
                vezes: 0,
                entrada: 0,
                result_total: 0,
                opcao_pagamento_id_parcelas: null,
                vencimento_primeira_parcela: null,
                vencimento: null,
            }
        };
    },
    props: {
        tarefa_id: Number,
        financeiro_id: Number,
    },
    watch: {
        'form.tipo_de_conta'(newVal, oldVal) {
            if (oldVal != null) {
                this.form.conta_id = null;
                this.form.conta_id_parcelas = null;
            }

        },
        'form.condicao_pagamento_id'(newValue) {
            if (newValue != 2) {
                this.form.entrada = 0;
                this.form.vezes = 0;
            }
        },
        'form.opcao_pagamento_id'(newValue) {
            if (newValue != 1)
                this.form.conta_id = null
        }
    },
    computed: {
        contasFilter() {
            return this.contas.filter((item) => item.data.tipo_de_conta == this.form.tipo_de_conta)
        }
    },
    created() {
        if (this.tarefa_id) {
            this.form.tarefa_id = this.tarefa_id;

        }
        if (this.financeiro_id) {
            this.form.id = this.financeiro_id;
            this.getServico();
        }

        this.getContas();

        this.getMomentoPagamento();


    },
    methods: {
        async getContas() {
            const result = await this.$api.get('financeiro-conta');
            this.contas = result.data;
        },
        async getMomentoPagamento() {
            let result = await this.$api.get('momento-pagamento');

            this.select_momento_pagamento = result.data;
        },
        async getServico() {


            const result = await this.$api.get(`financeiro/${this.financeiro_id}`);
            const obj = result.data;

            const keys = Object.keys(obj);
            keys.map(key => {
                if (key.endsWith("_id")) {
                    obj[key] = parseInt(obj[key]);
                }
            });

            obj.tipo_de_conta = parseInt(result.data.tipo_de_conta);

            if (result.data.vendas.length){
                obj.vencimento = result.data.vendas[0].vencimento;
                obj.opcao_pagamento_id = parseInt(result.data.vendas[0].opcao_pagamento_id);
            }

            if (result.data.vendas.length > 1) {
                obj.vencimento_primeira_parcela = result.data.vendas[1].vencimento;
                obj.conta_id_parcelas = parseInt(result.data.vendas[1].conta_id);
                obj.forma_pagamento_parcelas = parseInt(result.data.vendas[1].opcao_pagamento_id);
            }

            this.form = obj;

        },
        adicionaZero(numero) {
            if (numero <= 9) return "0" + numero;
            else return numero;
        },

        selectMomomentoPagamentoParcelas(e) {
            console.log("momento seleciona da parcela " + e.target.value);
        },

        converteMoedaFloat(valor) {
            if (valor === "") {
                valor = 0;
            } else {
                // valor = valor.replace(".", "");
                // valor = valor.replace(",", ".");
                valor = parseFloat(valor);
            }
            return valor;
        },
        calcular() {
            let entrada = this.form.entrada;
            const imposto =
                (this.form.preco *
                    this.converteMoedaFloat(this.form.imposto)) /
                100;

            let preco = this.form.total;
            if (this.form.preco > 0) {
                preco = this.form.preco;
                preco = preco + imposto;



                this.form.total = parseFloat(preco.toFixed(2));


            }

            if (entrada.length > 0) {
                entrada = this.converteMoedaFloat(entrada);

            }

            if (entrada >= preco && preco > 0.1) {
                this.$swal({
                    icon: "warning",
                    title: ` "O valor de entrada deve ser menor que o valor do preço total."`
                });


                this.form.entrada = 0;

                return;
            }


        },
        submit() {

            if (this.form.id) {
                this.$api.put(`financeiro/${this.form.id}`, this.form).then((result) => {
                    this.form.vendas = result.data.financeiro.vendas;
                    this.$emit('setForm', result.data.financeiro);

                });
            } else {
                this.$api.post('financeiro', this.form).then((result) => {


                    this.form.id = result.data.financeiro.id;
                    this.form.vendas = result.data.financeiro.vendas;
                    this.$emit('setForm', result.data.financeiro);

                });
            }

        }
    },
};
</script>
